import { Link, useLocation } from 'react-router-dom';
import imageError from '../../../assets/icons/error_img.svg';
import { NavHeader } from '../../../components';
import { useAuth } from '../../../context';
import { Container } from './style';

interface ErrorPageProps {
  statusCode?: number;
  message?: string;
}

export const NotFoundError: React.FC<ErrorPageProps> = ({
  statusCode,
  message,
}: ErrorPageProps) => {
  const { tokenIsValid } = useAuth();
  const { pathname } = useLocation();

  let status = Math.abs(Number(pathname.split('/')[2]));
  status = Number.isNaN(status) || status <= 300 || status >= 600 ? statusCode ?? 404 : status;

  return (
    <>
      <NavHeader typeHeader="default" />
      {/* <Body> */}
      <Container>
        <div className="cntAll">
          <div className="cnt-image">
            <img src={imageError} alt="" />
          </div>
          <div className="error-text">
            <div>
              <p className="letter-erro">ERRO</p>
              <p className="number-error">{status ?? 404}</p>
            </div>
            <span className="label-error">
              {message ?? 'A página solicitada parece que está fora do ar.'}
              <br />
              Use a nossa pesquisa ou volte para <Link to={tokenIsValid ? '/feed' : '/'}>
                home
              </Link>{' '}
              .
            </span>
          </div>
        </div>
      </Container>
    </>
  );
};
